import {
  createBaseThemeOptions,
  createUnifiedTheme,
  palettes,
} from '@backstage/theme';

const fontFamily = "'Inter', 'Noto Sans', sans-serif";

export const lightTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: { main: '#0072F5' },
      secondary: { main: '#7828C8' },
      error: { main: '#C9184A' },
      warning: { main: '#AE5A01' },
      info: { main: '#3A6DC9' },
      success: { main: '#317D33' },
      background: { default: '#F4F4F5', paper: '#FFFFFF' },
      text: { primary: '#141318', secondary: '#574F6D' },
      navigation: {
        background: '#EDE9F2',
        indicator: '#0072F5',
        color: '#574F6D',
        selectedColor: '#141318',
      },
    },
  }),
  fontFamily,
  defaultPageTheme: 'home',
});

export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: { main: '#6BABF7' },
      secondary: { main: '#9353D3' },
      error: { main: '#F75A68' },
      warning: { main: '#FFB26B' },
      info: { main: '#7FB8E8' },
      success: { main: '#95E09A' },
      background: { default: '#17191C', paper: '#262530' },
      text: { primary: '#F3F1F8', secondary: '#C5BFCF' },
      navigation: {
        background: '#1C1B21',
        indicator: '#6BABF7',
        color: '#C5BFCF',
        selectedColor: '#F3F1F8',
      },
    },
  }),
  fontFamily,
  defaultPageTheme: 'home',
});
